package com.imobly.imobly.api

import com.russhwolf.settings.Settings
import com.russhwolf.settings.get
import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logging
import io.ktor.http.URLProtocol
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

val settings: Settings = Settings()

fun createHttpClient(): HttpClient = HttpClient {
    install(ContentNegotiation) {
        json(Json {
            ignoreUnknownKeys = true
            coerceInputValues = true
            isLenient = true
        })
    }

    install(Logging) {
        level = LogLevel.ALL
    }

    defaultRequest {
        url {
            protocol = URLProtocol.HTTPS
            host = "edimoveis-backend.onrender.com"
        }
    }
}

fun getToken(): String {
    return settings.get<String>("AUTH_TOKEN") ?: ""
}

fun saveToken(token: String) {
    settings.putString("AUTH_TOKEN", token)
}

fun clearToken() {
    settings.remove("AUTH_TOKEN")
}